// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { getProgressiveLenses } from "../../../api";
import { ProgressiveLensType } from "../../../types";

export const useProgressiveLenses = (clinicId: string | undefined) => {
  const { getToken } = useTokenAccess();

  return useQuery<Array<ProgressiveLensType>>({
    queryKey: ["progressive-lenses", clinicId],
    queryFn: async () => {
      if (!clinicId) throw new Error();

      const token = await getToken();
      return getProgressiveLenses(token, clinicId);
    },
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // optional: cache for 5 minutes
  });
};
